import useSWR, { SWRResponse } from 'swr';
import { Garage } from '../../../providers/api/dtos/garage';
import { getGaragesByPropertyId } from '../../../providers/api/garage/garageProvider';

export const GARAGES_RID = '/property/:id/garages';

export default function useGarages(propertyId?: number): SWRResponse<Garage[], Error> {
  return useSWR(propertyId ? [GARAGES_RID, propertyId] : null, () => getGaragesByPropertyId(propertyId!));
}
